export default "__VITE_ASSET__Q7qhUL7X__"